import { ensureFlagStatusName } from '../ensureFlagStatusName';

export function parseStatusName(value: unknown) {
  try {
    return ensureFlagStatusName(value);
  } catch {
    return undefined;
  }
}
